module.exports = __webpack_public_path__ + "static/media/truck.b57fa237.svg";